export default __webpack_public_path__ + "static/heels2.inspirations-0ca3b47ef8d1f49fc380c570213e901c.jpg";